<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <cph-button @clicked="exportAll"
                            :buttonText="'export configuration'"
                            :classList="'btn btn-primary'">
                </cph-button>
                <cph-button @clicked="importAll"
                            :buttonText="'import configuration'"
                            :classList="'btn btn-cph-primary-outline'">
                </cph-button>
                <cph-button @clicked="deleteConfig"
                            :buttonText="'delete configuration'"
                            :classList="'btn btn-danger'">
                </cph-button>
                <!--<cph-button @clicked="getApiData"-->
                            <!--:buttonText="'Export api'"-->
                            <!--:classList="'btn btn-success'">-->
                <!--</cph-button>-->
            </div>
            <input type="file" ref="fileInput" class="hidden-input">
        </div>
    </div>
</template>

<script type="text/babel">
import ImportMixin from '../../../../mixins/importMixin.vue';
import CphButton from '../../../Shared/UI/Button/CphButton.vue';
import { ConfigPerimeter } from '../../../../router/perimeters/configPerimeter';

export default {
    name: 'CphConfig',
    data () {
        return {};
    },
    perimeters: [
        ConfigPerimeter
    ],
    components: {
        CphButton
    },
    mixins: [ImportMixin]
    
};

</script>

